import React, {useContext} from 'react'
import I18nContext from '../../../services/I18n/I18nContext'
import useStyles from './BusinessTypeSwitchStyles'
import CustomButton from '../CustomButton/CustomButton'

export const RENT_BUSINESS_TYPE = 'rent'
export const BUY_BUSINESS_TYPE = 'buy'
export const INCENTIVE_BUSINESS_TYPE = 'incentive'

interface ICustomButtonProps {
    businessType: string,
    handleChange: (businessType: string) => void
}

const BusinessTypeSwitch: React.FunctionComponent<ICustomButtonProps> = props => {

    const classes = useStyles()
    const {translate} = useContext(I18nContext)

    const handleChange = (businessType: string) => {
        props.handleChange(businessType)
    };

    return (
        <div className={classes.root}>
            <CustomButton onClick={() => handleChange(BUY_BUSINESS_TYPE)}
                          className={props.businessType === BUY_BUSINESS_TYPE ? classes.selected : classes.default}
                          textClass={props.businessType === BUY_BUSINESS_TYPE ? classes.selectedText : classes.defaultText}
                          style={{marginRight: 15, borderRadius: 100}}
                          text={translate('buy')}/>
            <CustomButton onClick={() => handleChange(RENT_BUSINESS_TYPE)}
                          className={props.businessType === RENT_BUSINESS_TYPE ? classes.selected : classes.default}
                          textClass={props.businessType === RENT_BUSINESS_TYPE ? classes.selectedText : classes.defaultText}
                          style={{marginRight: 15, borderRadius: 100}}
                          text={translate('rent')}/>
            <CustomButton onClick={() => handleChange(INCENTIVE_BUSINESS_TYPE)}
                          className={props.businessType === INCENTIVE_BUSINESS_TYPE ? classes.selected : classes.default}
                          textClass={props.businessType === INCENTIVE_BUSINESS_TYPE ? classes.selectedText : classes.defaultText}
                          style={{borderRadius: 100}}
                          text={translate('incentive')}/>
        </div>
    )

}

export default BusinessTypeSwitch
